/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Target_Pane_LabelInputs */



/**
* | output |
* | --- |
* | "Target File" |
*
* @param {Translation_Import_Target_Pane_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_target_pane_label = /** @type {((inputs?: Translation_Import_Target_Pane_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Target_Pane_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zieldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевой файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de destino")
	return /** @type {LocalizedString} */ ("Target File")
});